import initCallsAnalytics from "./calls";
import initFormAnalytics from "./forms";

const init = () => {
    initCallsAnalytics();
    initFormAnalytics();
}

export default init;